import { render, staticRenderFns } from "./DialogAlcohol.vue?vue&type=template&id=a2344592&scoped=true&"
import script from "./DialogAlcohol.vue?vue&type=script&lang=js&"
export * from "./DialogAlcohol.vue?vue&type=script&lang=js&"
import style0 from "./DialogAlcohol.vue?vue&type=style&index=0&id=a2344592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2344592",
  null
  
)

export default component.exports